<div class="summary-header">
  <span class="summary-header_q">
    Qu'est-ce qu'un profil de risque {{ riskStatus.toLowerCase() }} ?
  </span>
  <p class="summary-header__description">{{ description }}</p>
</div>
